import { detailFieldStyles } from '@v2/components';

export const styles = {
  fieldContainer: detailFieldStyles.fieldContainer,
  fieldFullWidth: 'tw-col-span-2',
  emptyText: 'tw-text-sm tw-text-neutral-500 tw-p-2',
  pluginGrid:
    'tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-2 tw-p-2 tw-max-h-[40vh] tw-overflow-y-auto tw-overflow-x-hidden tw-content-start tw-auto-rows-min tw-items-stretch',
  pluginCard:
    'tw-rounded-lg tw-border tw-border-neutral-200 tw-bg-white tw-p-3 tw-flex tw-flex-col tw-gap-1',
  pluginName: 'tw-font-medium tw-text-neutral-900 tw-text-sm',
  pluginMeta: 'tw-text-xs tw-text-neutral-500',
  statusBadge: 'tw-text-xs tw-font-medium',
  statusRunning: 'tw-text-green-600',
  statusInstalled: 'tw-text-blue-600',
  statusCached: 'tw-text-amber-600',
  statusDefault: 'tw-text-neutral-500',
};
